<template>
  <div class="activity">
    <img :src="url" alt="">
  </div>
</template>

<script>
import { isIOS } from "@/utils";
import { getDownloadBanner } from "../../api"

export default {
  name: 'Activity',
  data() {
    return {
      code: this.$route.query.adCode,
      url: ""
    }
  },
  created() {
    this.getConfigData()
  },
  methods: {
    getConfigData() {
      let params = {
        code: this.code
      }
      getDownloadBanner(params).then(res=> {
        console.log('接口返回: ', res)
        if (res.code === 200) {
          if (res.busCode === '1') {
            let data = res.data[0] || {}
            this.url = data.url
            let title = data.title || '活动说明'
            SetDocumentTitle.postMessage(title)
          } else {
            this.$toast({
              message: res.busMessage
            })
          }
        } else {
          this.$toast({
            message: res.message
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.activity{
  font-size: 0;
  img{
    width: 100%;
  }
}

</style>
